import * as endPoints from './endpoints/endpoints';
export { endPoints };
